<div *ngIf="initialized" class="flex-column gap-M">
	<div class="flex-align-center flex-space-between">
		<span class="font-MM fw-700">{{ 'page.appDetails.overview.functionalCapacities.functionalCapacities' | translate }}</span>
		<app-button-widget [disabled]="!isEditor" (onClick)="openDialog()" [loading]="_loading" [tooltip]="'readOnly.buttonTooltip' | translate" [tooltipDisabled]="isEditor" tooltipPosition="left">
			<img *ngIf="isEditor" width="12" src="assets/icons/add.svg" class="filter-primary" alt="">
			<img *ngIf="!isEditor" width="15" src="assets/icons/lock-01.svg">
		</app-button-widget>
	</div>
	<div *ngIf="applicationFunctionalCapacities.length > 0" class="flex gap-S flex-wrap">
		<div *ngFor="let capacity of applicationFunctionalCapacities" class="capacity-chip flex-align-center gap-XS p-relative" style="padding: 7px 10px;">
			<img *ngIf="capacity.icon" class="filter-white" [src]="'assets/icons/functional-capacities/' + capacity.icon + '.svg'" width="15" alt="">
			<span class="white text-overflow-ellipsis" style="max-width: 680px;">{{ capacity.name }}</span>
			<div *ngIf="isEditor" (click)="updateCapacities(capacity)" class="delete-capacity-button c-p p-absolute flex-center">
				<img src="assets/icons/close.svg" width="8">
			</div>
		</div>
	</div>
	<div *ngIf="applicationFunctionalCapacities.length <= 0" style="height: 220px" class="flex-center flex-column gap-M">
		<img src="assets/illustrations/empty-capacity.svg">
		<span class="grey">{{ 'page.appDetails.overview.functionalCapacities.noFunctionalCapacityApp' | translate }}</span>
	</div>
</div>
